import React from "react";
import ReactDOM from "react-dom";
import { Modal, Button } from "react-bootstrap";

const TextModal = ({ isShowing, toggle, titleText, bodyText }) => {
  return isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <Modal show={isShowing} onHide={toggle} centered>
            <Modal.Header closeButton>
              <Modal.Title>{titleText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{bodyText}</Modal.Body>

            <Modal.Footer>
              <Button
                variant="success"
                onClick={() => {
                  toggle();
                }}
              >
                Ok
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>,
        document.body
      )
    : null;
};

export default TextModal;
